import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

export const Wrapper = styled.div`
  // width: 800px;
  background: #f5f5f5;
  border-radius: 4px;
  box-shadow: 0 8px 8px rgb(0 0 0 / 10%);
`

export const Header = styled.div`
  padding: 16px;
  background-color: #404e67;
  color: #f5f5f5;
  font-size: 1.1rem;
  font-weight: bold;
  text-align: center;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`